import { render, staticRenderFns } from "./CallCard.vue?vue&type=template&id=13f11b9c&scoped=true"
import script from "./CallCard.vue?vue&type=script&lang=js"
export * from "./CallCard.vue?vue&type=script&lang=js"
import style0 from "./CallCard.vue?vue&type=style&index=0&id=13f11b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f11b9c",
  null
  
)

export default component.exports